module.exports = __webpack_public_path__ + "img/hr-heatex-S-idle.8d0613fb.png";